import { prop, round } from './utilities';

export function gaViewItem(product, adsId, goodId?: number) {
  if (product && Object.keys(product).length !== 0 && window.gtag) {
    window.gtag('event', 'view_item', {
      send_to: adsId,
      value: round(prop(product, 'main_good.final_price'), 2),
      items: [
        {
          id: goodId || prop(product, 'product_id'),
          google_business_vertical: 'retail',
        },
        {
          id: goodId || prop(product, 'product_id'),
          google_business_vertical: 'custom',
        },
      ],
    });
  }
}

export function gaAddToCart(product, adsId, goodId?: number) {
  if (product && Object.keys(product).length !== 0 && window.gtag) {
    window.gtag('event', 'add_to_cart', {
      send_to: adsId,
      value: round(prop(product, 'main_good.final_price'), 2),
      items: [
        {
          id: goodId || prop(product, 'product_id'),
          google_business_vertical: 'retail',
        },
        {
          id: goodId || prop(product, 'product_id'),
          google_business_vertical: 'custom',
        },
      ],
    });
  }
}

export function gaPurchase(order: any, adsId, goodId?: number) {
  if (order && Object.keys(order).length !== 0 && window.gtag) {
    const items: any = [];
    if (order.items && order.items.length) {
      order.items.map(item => {
        items.push({
          id: goodId || prop(item, 'product_id'),
          google_business_vertical: 'retail',
        });
        items.push({
          id: goodId || prop(item, 'product_id'),
          google_business_vertical: 'custom',
        });
      });
    }

    window.gtag('event', 'purchase', {
      send_to: adsId,
      value: order.order_tprice,
      items,
    });
  }
}

export function gaConversion(order: any, adsId) {
  if (order && Object.keys(order).length !== 0 && window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: adsId,
      value: order.order_tprice,
      currency: order.order_tpricecurrency,
      transaction_id: order.order_nr,
    });
  }
}

export function gaViewCategory(categoryData, adsId) {
  if (categoryData && Object.keys(categoryData).length !== 1 && window.gtag) {
    const total = categoryData.products.reduce((acc, item) => {
      acc += prop(item, 'main_good.final_price');
      return acc;
    }, 0);

    const items: any = [];
    if (categoryData.products && categoryData.products.length) {
      categoryData.products.map(item => {
        items.push({
          id: prop(item, 'product_id'),
          google_business_vertical: 'retail',
        });
        items.push({
          id: prop(item, 'product_id'),
          google_business_vertical: 'custom',
        });
      });
    }

    const ed = {
      send_to: adsId,
      value: round(total, 2),
      items,
    };
    window.gtag('event', 'view_item_list', ed);
  }
}

export function ga4ViewItem(product, adsId, currency = 'EUR') {
  if (product && Object.keys(product).length !== 0 && window.gtag) {
    window.gtag('event', 'view_item', {
      send_to: adsId,
      currency,
      items: [
        {
          item_id: prop(product, 'product_id'),
          item_name: prop(product, 'name'),
          price: round(prop(product, 'main_good.final_price'), 2),
        },
      ],
    });
  }
}

export function ga4AddToCart(
  product_id,
  product_name,
  product_count: number,
  product_unit_price,
  adsId,
  currency = 'EUR',
) {
  if (product_id && window.gtag) {
    window.gtag('event', 'add_to_cart', {
      send_to: adsId,
      items: [
        {
          item_id: product_id,
          item_name: product_name,
          quantity: product_count,
          price: product_unit_price,
          currency,
        },
      ],
    });
  }
}
export function ga4BeginCheckout(cartProducts, adsId, currency = 'EUR') {
  if (cartProducts && window.gtag) {
    const gProducts = cartProducts.map(p => {
      return {
        item_id: prop(p, 'good.product_id'),
        item_name: prop(p, 'product.name'),
        quantity: prop(p, 'count'),
        price: prop(p, 'good.final_price'),
      };
    });
    window.gtag('event', 'begin_checkout', {
      send_to: adsId,
      currency,
      items: [...gProducts],
    });
  }
}
export function ga4AddShippingInfo(
  cartProducts,
  shipping_tier,
  adsId,
  currency = 'EUR',
) {
  if (cartProducts && window.gtag) {
    const gProducts = cartProducts.map(p => {
      return {
        item_id: prop(p, 'good.product_id'),
        item_name: prop(p, 'product.name'),
        quantity: prop(p, 'count'),
        price: prop(p, 'good.final_price'),
      };
    });
    window.gtag('event', 'add_shipping_info', {
      send_to: adsId,
      currency,
      items: [...gProducts],
      shipping_tier,
    });
  }
}
export function ga4AddPaymentInfo(
  cartProducts,
  payment_type,
  adsId,
  currency = 'EUR',
) {
  if (cartProducts && window.gtag) {
    const gProducts = cartProducts.map(p => {
      return {
        item_id: p.good.product_id,
        item_name: p.product.name,
        quantity: p.count,
        price: p.good.final_price,
      };
    });
    window.gtag('event', 'add_payment_info', {
      send_to: adsId,
      currency,
      items: [...gProducts],
      payment_type,
    });
  }
}
export function ga4Purchase(
  cartProducts,
  transaction_id = 0,
  shipping = 0,
  value = 0,
  tax = 0,
  adsId,
  currency = 'EUR',
) {
  if (cartProducts && window.gtag) {
    const gProducts = cartProducts.map(p => {
      return {
        item_id: p.product_id,
        item_name: p.product_name,
        quantity: p.quantity,
        price: p.unitprice,
      };
    });
    window.gtag('event', 'purchase', {
      send_to: adsId,
      currency,
      items: [...gProducts],
      transaction_id,
      shipping,
      value,
      tax,
    });
  }
}
export function ga4ViewCategory(
  categoryData,
  category,
  adsId,
  currency = 'EUR',
) {
  if (categoryData && Object.keys(categoryData).length !== 1 && window.gtag) {
    const items: any = [];
    if (categoryData.products && categoryData.products.length) {
      categoryData.products.map(item => {
        items.push({
          item_id: prop(item, 'product_id'),
          item_name: prop(item, 'name'),
          price: prop(item, 'max_price'),
          currency,
        });
      });
    }
    const ed = {
      send_to: adsId,
      item_list_name: prop(category, 'category_name'),
      item_list_id: prop(category, 'category_id'),
      items,
    };
    window.gtag('event', 'view_item_list', ed);
  }
}
